import { mapMutations, mapState } from 'vuex';
import GoogleMapsApiLoader from 'google-maps-api-loader';

import listenOnRootMixin from '@/mixins/listen-on-root';
import { SET_COORDINATES } from '@/store/types/mutation-types';
import store from '@/store/store';

const CUSTOM_ATTR_NAME = 'google-map-data';

export default {
    mixins: [listenOnRootMixin],

    data() {
        return {
            geocoder: null,
        };
    },

    computed: {
        ...mapState({
            settings: state => state.settings,
            coordinates: state => state.coordinates,
        }),
    },

    async beforeMount() {
        if (this.hasElementData(CUSTOM_ATTR_NAME)) {
            const savedData = this.getElementData(CUSTOM_ATTR_NAME);

            if (savedData.coordinates) {
                this.setCoordinates(savedData.coordinates);
            }
        }
    },

    methods: {
        ...mapMutations({
            setCoordinates: state => state.setCoordinates,
        }),

        async loadGoogleMapsApi() {
            // loading google multiple times will cause an error
            // if we're already requesting maps api return that promise
            // otherwise create a new request
            if (!window.flexGoogleApiLoader) {
                window.flexGoogleApiLoader = GoogleMapsApiLoader({
                    apiKey: this.settings.google.mapsKey,
                });
            }
            return window.flexGoogleApiLoader;
        },

        async resolveZipCode(zipCode) {
            if (this.coordinates && this.coordinates.zipCode === zipCode) {
                return this.coordinates;
            }
            if (!window.google) {
                await this.loadGoogleMapsApi();
            }
            if (window.google) {
                if (!this.geocoder) {
                    this.geocoder = new window.google.maps.Geocoder();
                }

                if (this.geocoder) {
                    const promise = new Promise((resolve, reject) => {
                        this.geocoder.geocode({ address: `zipcode ${ zipCode }` },
                            (results, status) => {
                                if (status === 'OK') {
                                    const coordinates = {
                                        lat: results[0].geometry.location.lat(),
                                        lng: results[0].geometry.location.lng(),
                                        zipCode,
                                    };
                                    resolve(coordinates);
                                } else {
                                    reject(new Error(status));
                                }
                            });
                    });

                    const result = await promise;

                    if (!(result instanceof Error)) {
                        this.setCoordinates(result);
                    }

                    return this.coordinates;
                }
            }
        },

        setCoordinates(val) {
            store.commit(SET_COORDINATES, val);
        },
    },
};
